<template>
  <aside
    id="navigation"
    role="page-head"
    :class="{ 'navi-open': isOpenNav }"
    class="page-side"
  >
    <template v-if="extraMenus && extraMenus[0]">
      <naviWrapp
        v-for="(extra, i) in extraMenus"
        :borderColor="menuColor(extra)"
        :style="'--menuColor:'+menuColor(extra)"
        class="custom-menu"
        :key="i + '-menu'"
      >
        <div v-if="extra.logo" @click="clickExtraMenu(i)">
          <WpImage  :data="extra.logo" class="menu-logo" />
        </div>
        <WpNavi
          :class="{'no-logo' : !extra.logo}"
          class="extraMenu start-menu"
          :ref="'extraMenu-' + i"
          :id="extra.menu"
        />
      </naviWrapp>
    </template>
    <WpNavi class="standard-menu" location="primary-menu" />
    <SearchForm @submit="makeSearch" :placeholder="searchPlaceholder" />
  </aside>
</template>

<script>
import WpNavi from "@/components/elements/WpNavi";
import WpImage from "@/components/elements/WpImage";
import SearchForm from "@/components/blocks/SearchForm";

import { mapGetters, mapMutations } from "vuex";

import styled from "vue-styled-components";

const naviWrapProps = { borderColor: String };
const naviWrapp = styled("div", naviWrapProps)`
  ${props => ""};
`;

export default {
  name: "theme-navigation",
  components: {
    WpNavi,
    WpImage,
    naviWrapp,
    SearchForm
  },
  data() {
    return {
      home_url: window.WPVUE.home_url,
      site_name: window.WPVUE.site_name,
      naviOpen: false,
      extraMenus: window.WPVUE.options.menus_special,
      searchPlaceholder: "Søk på nettsiden",
      mQview: null
    };
  },
  mounted() {
    this.mQview = window.matchMedia("screen and (max-width: 1199px)");
  },
  computed: {
    ...mapGetters(["isOpenNav", "currentTheme"]),
    route() {
      return this.$route.path;
    }
  },
  watch: {
    $route(to, from) {
      setTimeout(() => {
        $(".extraMenu").each((i, e) => {
          let hasClass = false;
          hasClass = $(e).hasClass("has-active-items");
          // console.log({e ,hasClass})
        });
      }, 200);
    }
  },

  methods: {
    checkerFunction(MQvp) {
      if (MQvp.matches) {
        // viewport <= 1199px
        this.logoImageType = "dark";
      } else {
        // viewport > 1199px
        this.logoImageType = this.type;
      }
    },
    ...mapMutations({
      setHeaderStatus: "SET_NAVIGATION_STATUS"
    }),
    clickExtraMenu(i) {
      $(this.$refs["extraMenu-" + i][0].$el)
        .find("> .link-list > a")[0]
        .click();
    },
    menuColor(menu) {
      let theme = "#64134a";
      if (menu && menu.color) {
        theme = menu.color;
      }
      return theme;
    },
    makeSearch(e) {
      if (e) {
        this.$router.replace({
          name: "search",
          query: { ...this.$route.query, search: e }
        });
        if (this.isOpenNav && this.mQview.matches) {
          this.setHeaderStatus(false);
        }
      }
    }
  }
};
</script>

<style lang="scss">
@import "./../assets/scss/mixins.scss";
@import "./../assets/scss/vars.scss";
//.page-side .wp-navi-links.has-link-active > .link-list
//.page-side .wp-navi-links .level-2 .link-list
//.page-side .level-2 .list-link-active.has-childs

.page-side {
  padding-top: 72px;
  @include mquery(499px) {
    padding-top: 62px;
  }
  .search-form {
    background-color: #fff;
    padding-top: 28px;
    .input-holder .icon {
      svg g {
        fill: $fontColor;
      }
    }
    .input-holder .input-with-icon {
      background-color: #fff;
      color: $fontColor;
      border: 2px solid $fontColor;
      &::placeholder {
        color: $fontColor;
      }
    }
    &.padding_large {
      @include mquery(499px) {
        padding: 15px 50px 50px;
      }
    }
  }
  .custom-menu {
    position: relative;
    min-height: 50px;
      .has-active-items > .link-list{
        display: block !important
    }
    .menu-logo {
      cursor: pointer;
      margin: 0;
      padding: 0 0 15px 0;
      display: block;
      position: absolute;
      z-index: 10;
      top: 25px;
      left: 50px;
      img {
        max-height: 32px;
      }
    }
    .start-menu {
      margin: 0;
      padding: 55px 50px 0;
      &.has-active-items {
        padding-top: 80px;
        padding-bottom: 25px;
        margin-bottom: 5px;
        background: $colorGray;
      }
    }
    ~ .custom-menu {
      .top-level {
        &.has-active-items {
          //margin-top: 30px;
        }
      }
    }
    .no-logo.top-level{
      //padding-top: 30px;
      padding-top: 0px;
        &.has-active-items {
          padding-top: 30px;
        }
      > .link-list {
        &.has-childs{
          > a {
            margin-bottom: 10px;
          }
        }
        > a {
          display: inline-block;
          font-size: 25px;
          font-weight: 700;
        }
      }
    } 
    .top-level > .link-list > a {
      display: none;

      // &.router-link-active {
      //   ~ {
      //     .level-2 > .link-list > a {
      //       border-bottom: 2px solid transparent;
      //       &:hover {
      //         border-bottom: 2px solid var(--menuColor, $purple);
      //       }
      //     }
      //     .level-3 > .link-list > a {
      //       border-bottom: 2px solid transparent;
      //       &:hover {
      //         border-bottom: 2px solid var(--menuColor, $purple);
      //       }
      //     }
      //   }
      // }
    }
  }
  .standard-menu {
    margin-bottom: 0;
    margin-top: 0;
    padding-top: 28px;
    padding-left: 50px;
    & > .link-list {
      margin-bottom: 10px;
      & > a {
        font-weight: 700;
        font-size: 18px;
      }
      &.link-navi {
        margin-top: 10px;
      }
    }
    &.has-active-items {
      > .list-link-active {
        padding-top: 25px;
        padding-bottom: 25px;
        background: $colorGray;
        position: relative;
        margin-bottom: 15px;
        > a{
          margin-bottom: 10px;
        }
        &:after {
          content: "";
          position: absolute;
          top: 0;
          bottom: 0;
          left: -50px;
          width: 100%;
          z-index: -1;
          background-color: $colorGray;
        }
      }
    }
    > .link-list > a {
      font-size: 19px;
    }
    .level-2 {
      > .link-list > a {
        font-size: 17px;
      }
    }
    .level-3 {
      > .link-list > a {
        font-size: 16px;
      }
    }
    .level-4 {
      > .link-list > a {
        font-size: 15px;
      }
    }
    .level-5 {
      > .link-list > a {
        font-size: 14px;
      }
    }
  }
  .router-link-exact-active {
    font-weight: 700;
    &.has-child {
      padding-bottom: 10px;
    }
    &:hover {
      font-weight: 700 !important;
    }
  }

  .wp-navi-links {
    list-style: none;
    &.has-active-items {
      //margin-top: 10px;
      .router-link-active {
        //margin-bottom: 10px;
      }
    }
    &.has-link-active {
      //background: red;
    }
    a {
      text-decoration: none;
      color: inherit;
      display: inline-block;
      &:hover {
        font-weight: 400;
      }
    }
    &.has-link-active {
      > .link-list {
        display: block !important;
      }
    }
    .level-2 {
      &.has-active-items{
        > .link-list > a{
          margin-bottom: 5px;
        }
      }
      .link-list {
        display: none;
      }
    }
    .wp-navi-links {
      padding-left: 13px;
    }
  }
  .link-list > a{
    border-bottom: 2px solid transparent;
    &:hover {
      border-bottom: 2px solid var(--menuColor, $purple) !important;
    }
  }
  .top-level > .link-list > a {
    border-bottom: 2px solid transparent;
    &:hover {
      border-bottom: 2px solid var(--menuColor, $purple);
      font-weight: 700 !important;
      ~ {
        /* .level-2{
                    opacity: 1;
                    visibility: visible;
                    border-left: 4px solid red
                } */
      }
    }
  }
  .level-1 {
    .wp-navi-links {
      padding-left: 0;
    }
  }
  .level-2 {
    .wp-navi-links {
      padding-left: 13px;
    }
    > .link-list > a {
      font-size: 19px;
      border-bottom: 2px solid transparent;
      //font-weight: 400;
    }
    .list-link-active {
      &.has-childs {
        //margin-top: 10px;
        margin-bottom: 10px;
      }
    }
  }
  .level-3 {
      border-left: 2px solid var(--menuColor, $purple);
    > .link-list > a {
      font-size: 18px;
      border-bottom: 2px solid transparent;
      //font-weight: 400;
    }
    &.wp-navi-links {
      .router-link-active {
        //margin-bottom: 5px;
      }
    }
  }
  .level-4 {
    border-left: 2px solid var(--menuColor, $purple);
    margin-top: 0;
    > .wp-navi-links {
      padding-left: 0;
    }
    > .link-list > a {
      font-size: 16px;
      border-bottom: 2px solid transparent;
      //font-weight: 400;
    }
    &.has-link-active {
      margin-bottom: 5px;
    }
    .link-navi {
      margin-bottom: 5px;
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
  .level-5 {
      border-left: 2px solid var(--menuColor, $purple);
     > .wp-navi-links{
        padding-left: 13px;
      }
      > .link-list > a {
        font-size: 14px;
      }
  }

}
</style>
